<template>
    <div class="list-container">
      <b-row align-h="end">
        <b-col cols="1" class="text-right">
          <div id="buttonHolder" style="float: right; margin-bottom: 5px;">
            <b-input-group-append>
              <b-btn class="mr-2; ml-2" pill>
                <font-awesome-icon :icon="['fas', 'plus-circle']" @click="add()"
                />
              </b-btn>
            </b-input-group-append>
          </div>
        </b-col>
      </b-row>
      <div class="list-group" v-for="(choice,k) in items" :key="k" style="width: 100%;">
        <!--<input type="text" ref="questText" class="form-control" :value="choice.itemName" @input="updateDate()">-->
        <b-input-group class="mb-2" label-cols="4" label-cols-lg="2" label-size="md" label="Name:"
                       label-for="input-md">
          <b-form-input class="w-75" id="input-md" size="md" v-model="items[k]"
                        @input="updateDate()"></b-form-input>

          <b-input-group-append>
            <b-btn class="mr-2; ml-2" pill v-show="k || ( !k && items.length > 1)">
              <font-awesome-icon :icon="['fas', 'minus-circle']" @click="remove(k)"
                                           v-show="k || ( !k && items.length > 1)"/>
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
        </div>
    </div>
</template>
<script>

    export default {
        props: ['value'],
        data: function () {
            return {
                items: this.value
            }
        },
        methods: {
            updateDate(e) {
              console.debug("Update ListControl");
              this.$emit('input', this.items);
            },
            add(index) {
              this.items.push("Question Option " + (this.items.length + 1));
              console.debug("Added Option");
            },
            remove(index) {
                this.items.splice(index, 1);
            },
            addChoice(index) {
                console.error("full mane");
            }
        }
    }
</script>
<style>
    div.list-container {
        padding-left: 10px;
    }
</style>
